import { CONFIG } from '../config/config';
import { ANALYSIS_PROMPT } from '../config/prompts';

export class GeminiService {
  static async analyzeVideo(videoFile) {
    const videoBase64 = await this.convertToBase64(videoFile);

    const videoPart = {
      inlineData: {
        mimeType: videoFile.type,
        data: videoBase64
      }
    };

    const response = await fetch(
      `${CONFIG.GEMINI_API_URL}?key=${CONFIG.GEMINI_API_KEY}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          contents: [{
            parts: [
              { text: ANALYSIS_PROMPT },
              videoPart
            ],
          }],
          generationConfig: {
            temperature: 0.2
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(`Analysis failed: ${response.status}`);
    }

    const data = await response.json();
    let analysisText = data.candidates[0].content.parts[0].text;

    analysisText = analysisText.replace(/```json\n?/g, "").replace(/```\n?/g, "").trim();

    return JSON.parse(analysisText);
  }

  static convertToBase64(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.readAsDataURL(file);
    });
  }
}